module.exports = {
  A: { api: 'A', human: 'Autohändler' },
  H: { api: 'H', human: 'Halter' },
  M: { api: 'M', human: 'Mobile' }
}
